import React from "react";
import { benefitsList } from "./benefitsUtils";
import BenefitsListItem from "./BenefitsListItem";
import {
  StyledHomePageBenefitsBlock,
  StyledHomePageBenefitsContainer,
  StyledHomePageBenefitsList,
  StyledHomePageBenefitsWrapper
} from "./styledHomePageBenefits";
import { motion } from "framer-motion";
import { StyledMainTitleHomePage } from "../styledHomePage";
import { HookResponsive } from "../../elements/customHooks/HookResponsive";

const HomePageBenefits = () => {

  const benefitsTitleAnimation = {
    hidden: {
      x: -50,
      opacity: 0
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: { delay: 0.2 }
    }
  };

  const benefitsItemsAnimation = {
    hidden: {
      y: -40,
      opacity: 0
    },
    visible: custom => ({
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 200, damping: 10, delay: custom * 0.2 }
    })
  };

  return (
    <StyledHomePageBenefitsWrapper
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.2 }}
    >
      <StyledHomePageBenefitsContainer>
        <StyledHomePageBenefitsBlock>
          <motion.div
            custom={2}
            variants={HookResponsive() ? benefitsTitleAnimation : null}
          >
            <StyledMainTitleHomePage
              className="benefits-title"
              color="white"
              position="center"
              as="h5"
              mb="40"
              size="50"
              lineHeight="61"
              weight="700"
            >
              Benefits
            </StyledMainTitleHomePage>
          </motion.div>
          <StyledHomePageBenefitsList>
            {benefitsList.map((item, key) => (
              <BenefitsListItem
                key={key}
                item={item}
                custom={key}
                variants={HookResponsive() ? benefitsItemsAnimation : null}
              />
            ))}
          </StyledHomePageBenefitsList>
        </StyledHomePageBenefitsBlock>
      </StyledHomePageBenefitsContainer>
    </StyledHomePageBenefitsWrapper>
  );
};

export default HomePageBenefits;